// @flow
import { CategoriasActionTypes } from './constants';

type CategoriasAction = { type: string, payload: {} | string };

// common success
export const categoriasApiResponseSuccess = (actionType: string, data: any): CategoriasAction => ({
    type: CategoriasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const categoriasApiResponseError = (actionType: string, error: string): CategoriasAction => ({
    type: CategoriasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategoria = (id: string): CategoriasAction => ({
    type: CategoriasActionTypes.GET_CATEGORIA,
    payload: { id },
});

export const addCategoria = (categoria:any):CategoriasAction=>({
    type:CategoriasActionTypes.ADD_CATEGORIA,
    payload:categoria
})
export const updateCategoria = (categoria:any):CategoriasAction=>({
    type:CategoriasActionTypes.UPDATE_CATEGORIA,
    payload:categoria
})
export const deleteCategoria = (id:string):CategoriasAction=>({
    type:CategoriasActionTypes.DELETE_CATEGORIA,
    payload:{id}
})

export const listCategorias = (params:any): CategoriasAction => ({
    type: CategoriasActionTypes.LIST_CATEGORIAS,
    payload: params,
});


export const resetCategorias = (): CategoriasAction => ({
    type: CategoriasActionTypes.RESET,
    payload: {},
});

